/**
 * 热线模块（src/views/hotline）英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：AttendantConsole/（话务台）、CallHistory/（通话记录）、OperatorManagement/（话务员管理）、
 *           KnowledgeBaseManagement(.Modal)（知识库管理）
 * 术语：热线=Hotline，坐席=Agent，话务员=Operator，来电=Incoming Call，去电=Outgoing Call，
 *       通话记录=Call History，工单=Work Order，接听=Answer，挂断=Hang up，转接=Transfer，
 *       忙=Busy，空闲=Idle，报装=Installation，换表=Meter Replacement，过户=Ownership Transfer，
 *       知识库=Knowledge Base，营业厅=Business Hall，留言=Message，回访=Follow-up
 * 通用词（确定/取消/关闭/查询/重置/新增/删除/编辑/详情/更多/操作/创建时间/创建人/是/否/其他 等）
 * 已在 en-US.js 中定义，此处不再重复（个别复用以保持模块自洽）
 * 注：constant 常量映射（protocolConstant/commonConstant）中经 $t 输出的值（通讯状态/上报方式/
 *     阀门状态/运营商/操作类型/缴费途径等）在此补充译文
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '删除': 'Delete',
  '编辑': 'Edit',
  '详情': 'Details',
  '更多': 'More',
  '操作': 'Action',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '是': 'Yes',
  '否': 'No',
  '其他': 'Other',
  '确定删除吗?': 'Are you sure you want to delete?',
  '未知': 'Unknown',
  '结束': 'Finished',
  '保存': 'Save',
  '复制': 'Copy',
  '下载': 'Download',
  '添加': 'Add',
  '全部': 'All',
  '元': 'CNY',
  '无': 'None',
  '来源': 'Source',
  '状态': 'Status',
  '预览': 'Preview',
  '通过': 'Approve',
  '驳回': 'Reject',
  '撤销': 'Revoke',
  '备注': 'Remark',
  '计算公式': 'Formula',
  '项目名称': 'Item Name',

  // ── 通用提示 ──
  '操作成功': 'Operation successful',
  '保存成功!': 'Saved successfully!',
  '删除成功!': 'Deleted successfully!',
  '复制成功': 'Copied successfully',
  '不支持复制': 'Copy Not Supported',
  '未查询到数据！': 'No data found!',
  '确认删除': 'Confirm Deletion',
  '确定要删除此区域{name}以及子节点数据吗?': 'Are you sure to delete area {name} and all its child nodes?',
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '暂无附件': 'No attachment',
  '无图片': 'No Image',
  '无文件': 'No File',

  // ── 用户/表具 ──
  '用户编号': 'Customer No.',
  '用户姓名': 'Customer Name',
  '用户名称': 'Customer Name',
  '用户电话': 'Customer Phone',
  '用户手机号': 'Customer Mobile Phone',
  '用户地址': 'Customer Address',
  '用户状态': 'Customer Status',
  '用户基本信息': 'Customer Basic Information',
  '用户水表编号': 'Customer Water Meter No.',
  '用户满意度': 'Customer Satisfaction',
  '用户过户': 'Customer Ownership Transfer',
  '用户信息变更': 'Customer Info Change',
  '已激活': 'Activated',
  '未激活': 'Not Activated',
  '激活时间': 'Activation Time',
  '表编号': 'Meter No.',
  '表类型': 'Meter Type',
  '表安装地址': 'Meter Installation Address',
  '表端时间': 'Meter Time',
  '表具实时数据': 'Meter Real-time Data',
  '册号': 'Register No.',
  '阀门是否故障': 'Valve Fault',
  '阀门状态': 'Valve Status',
  '阀控状态': 'Valve Control Status',
  '上报累计流量(m³)': 'Reported Total Flow (m³)',
  '电池电压(V)': 'Battery Voltage (V)',
  '上报时间': 'Report Time',
  '上报方式': 'Report Method',
  '运营商': 'Carrier',
  '日用量(m³)': 'Daily Usage (m³)',
  '报表日期': 'Report Date',
  '激活计费': 'Activation Billing',
  '上报计费': 'Reported Billing',
  '刷卡计费': 'Card Billing',
  '移动': 'China Mobile',
  '联通': 'China Unicom',
  '电信OC': 'China Telecom OC',
  '电信AEP': 'China Telecom AEP',
  '正常': 'Normal',
  '故障': 'Fault',
  '无阀控': 'No Valve Control',
  '有阀控': 'With Valve Control',
  '定时上报': 'Scheduled Report',
  '上电上报': 'Power-on Report',
  '手动上报': 'Manual Report',
  '故障上报': 'Fault Report',
  '阀门动作上报': 'Valve Action Report',
  '读卡上报': 'Card Read Report',
  '高频上报': 'High-frequency Report',
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',
  '强制开阀': 'Force Open Valve',
  '强制关阀': 'Force Close Valve',
  '阀门开故障': 'Valve Open Fault',
  '阀门关故障': 'Valve Close Fault',
  '无阀': 'No Valve',
  '阀门锈死故障': 'Rusted Valve Fault',
  '无到位信号': 'No In-place Signal',
  '未发送': 'Not Sent',
  '正在下发': 'Dispatching',
  '已下达': 'Issued',
  '执行成功': 'Executed Successfully',
  '已取消': 'Cancelled',
  '执行失败': 'Execution Failed',
  '过期未执行': 'Expired, Not Executed',

  // ── 话务台：工单信息（WorkOrderRecord）──
  '工单信息': 'Work Order Information',
  '新建工单': 'New Work Order',
  '工单编号': 'Work Order No.',
  '工单类型': 'Work Order Type',
  '工单紧急程度': 'Work Order Urgency',
  '工单状态': 'Work Order Status',
  '工单联系人': 'Work Order Contact',
  '工单详情': 'Work Order Details',
  '当前节点处理人': 'Current Node Handler',
  '联系电话': 'Contact Phone',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '更新时间': 'Updated At',
  '换表': 'Meter Replacement',
  '工程报装': 'Engineering Installation',
  '故障报修': 'Fault Repair',
  '未开启': 'Not Started',
  '换表登记': 'Meter Replacement Registration',
  '旧表审核': 'Old Meter Review',
  '绑定新表': 'Bind New Meter',
  '安装': 'Install',
  '安装成功': 'Installed successfully',
  '审核工单': 'Work Order Review',
  '报装申请': 'Installation Application',
  '报装受理': 'Installation Acceptance',
  '报装勘察设计': 'Installation Survey & Design',
  '报装预算': 'Installation Budget',
  '报装审批': 'Installation Approval',
  '报装收费': 'Installation Fee Collection',
  '报装施工': 'Installation Construction',
  '报装建档': 'Installation Filing',
  '登记': 'Registration',
  '接单': 'Accept',
  '归档': 'Archive',
  '微信端游客': 'WeChat Guest',
  '开启成功': 'Started successfully',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '受理': 'Acceptance',
  '勘察设计': 'Survey & Design',
  '预算': 'Budget',
  '收费': 'Fee Collection',
  '施工': 'Construction',
  '验收': 'Completion Acceptance',
  '报装验收': 'Installation Final Acceptance',
  '建档': 'Filing',

  // ── 话务台：交易/缴费记录（DeductionRecord/PaymentRecords）──
  '交易记录': 'Transaction Records',
  '缴费记录': 'Payment Records',
  '上期累计(m³)': 'Previous Cumulative (m³)',
  '上期余额(元)': 'Previous Balance (CNY)',
  '本期累计(m³)': 'Current Cumulative (m³)',
  '本期使用(m³)': 'Current Usage (m³)',
  '金额变动(元)': 'Amount Change (CNY)',
  '本期余额(元)': 'Current Balance (CNY)',
  '计费时间': 'Billing Time',
  '操作人': 'Operated By',
  '操作类型': 'Operation Type',
  '购买金额(元)': 'Purchase Amount (CNY)',
  '购买量(吨)': 'Purchase Volume (t)',
  '缴费途径': 'Payment Channel',
  '交易流水号': 'Transaction Serial No.',
  '剩余金额(元)': 'Remaining Balance (CNY)',
  '缴费时间': 'Payment Time',
  '操作员': 'Operator',
  '充值': 'Recharge',
  '退费': 'Refund',
  '补水': 'Water Supplement',
  '撤销充值': 'Revoke Recharge',
  '撤销退费': 'Revoke Refund',
  '撤销补水': 'Revoke Water Supplement',
  '恢复撤销充值': 'Restore Revoked Recharge',
  '恢复撤销补水': 'Restore Revoked Water Recharge',
  '恢复撤销退费': 'Restore Revoked Refund',
  '退费撤销': 'Refund Revoked',
  '营业厅现金': 'Cash at Business Hall',
  '扫码支付': 'QR Code Payment',
  '对公转账': 'Corporate Bank Transfer',
  '微信支付': 'WeChat Pay',

  // ── 话务台：价格信息（priceIndex/PriceAdjustmentRecord）──
  '价格信息': 'Price Info',
  '价格名称': 'Price Name',
  '阶梯数量': 'Number of Tiers',
  '禁用状态': 'Disabled Status',
  '计费类型': 'Billing Type',
  '阶梯计费方式': 'Tiered Billing Method',
  '收起': 'Collapse',
  '展开': 'Expand',
  '水价总计(元)': 'Total Water Price (CNY)',
  '基本水价(元)': 'Basic Water Price (CNY)',
  '基本单价': 'Basic Unit Price',
  '收取方式': 'Collection Method',
  '按量': 'By Volume',
  '单价（元）': 'Unit Price (CNY)',
  '水费类型': 'Water Fee Type',
  '是否收取违约金': 'Late Fee Enabled',
  '调价记录': 'Price Adjustment Records',
  '旧价格信息': 'Old Price Info',
  '新价格信息': 'New Price Info',
  '变更方式': 'Change Method',
  '立即结算': 'Settle Immediately',
  '扣完再启用新价格': 'Enable New Price After Deduction',
  '新价格启用日期': 'New Price Effective Date',
  '价格信息变更': 'Price Info Change',
  '请输入价格名称模糊搜索': 'Enter price name to search',
  '请选择阶梯数量': 'Please select the number of tiers',
  '请选择禁用状态': 'Please select disabled status',
  '请选择计费方式': 'Please select billing method',

  // ── 话务台：营业网点（BusinessOutlets）──
  '营业网点': 'Business Outlets',
  '营业厅名称': 'Business Hall Name',
  '营业厅电话': 'Business Hall Phone',
  '营业厅工作日': 'Business Hall Working Days',
  '营业厅经度': 'Business Hall Longitude',
  '营业厅纬度': 'Business Hall Latitude',
  '营业厅地址': 'Business Hall Address',
  '请输入营业厅名称': 'Please enter the business hall name',

  // ── 话务台：留言信息（MessageInformation）──
  '留言信息': 'Message Information',
  '留言类型': 'Message Type',
  '联系人名称': 'Contact Name',
  '联系人电话': 'Contact Phone',
  '精确地址': 'Exact Address',
  '情况描述': 'Situation Description',
  '处理人': 'Handler',
  '处理时间': 'Handling Time',
  '未处理': 'Unprocessed',
  '已处理': 'Processed',
  '咨询': 'Inquiry',
  '建议': 'Suggestion',
  '投诉': 'Complaint',
  '处理中': 'Processing',
  '等待评价': 'Awaiting Evaluation',
  '客服热线': 'Customer Service Hotline',
  '请输入联系人电话': 'Please enter the contact phone',
  '请选择状态': 'Select status',
  '请选择留言类型': 'Please select the message type',

  // ── 话务台：换表/过户记录（RecordOfTableReplacement/TransferRecord）──
  '换表记录': 'Meter Replacement Records',
  '过户记录': 'Ownership Transfer Records',
  '旧表编号': 'Old Meter No.',
  '新表编号': 'New Meter No.',
  '旧表结算流量(m³)': 'Old Meter Settlement Flow (m³)',
  '新表起始读数(m³)': 'New Meter Initial Reading (m³)',
  '旧表机械读数(m³)': 'Old Meter Mechanical Reading (m³)',
  '换表原因': 'Meter Replacement Reason',
  '换表结算余额(元)': 'Balance After Replacement Settlement (CNY)',
  '操作时间': 'Operation Time',
  '新用户姓名': 'New Customer Name',
  '原用户姓名': 'Original Customer Name',
  '新用户手机号': 'New Customer Mobile Phone',
  '原用户手机号': 'Original Customer Mobile Phone',
  '新身份证号': 'New ID Number',
  '原身份证号': 'Original ID Number',
  '原价格信息': 'Original Price Info',

  // ── 话务台：微信申请/故障报修（WeChatApplication/WeChatApplicationRecord）──
  '待办': 'To Do',
  '已办': 'Done',
  '微信申请': 'WeChat Application',
  '微信故障报修申请': 'WeChat Fault Repair Application',
  '申请类型': 'Application Type',
  '审批人': 'Approver',
  '审批状态': 'Approval Status',
  '审批时间': 'Approval Time',
  '审批历史': 'Approval History',
  '待审批': 'Pending Approval',
  '审批中': 'Under Approval',
  '报停': 'Suspension',
  '报停恢复': 'Service Resumption',
  '销户': 'Account Cancellation',
  '工单类': 'Work Order',
  '营收类': 'Billing',
  '草稿': 'Draft',
  '处理结束': 'Processing Completed',
  '报修人名称': 'Reporter Name',
  '报修人电话': 'Reporter Phone',
  '报修地址': 'Repair Address',
  '报修描述': 'Repair Description',
  '报修时间': 'Report Time',

  // ── 知识库（KnowledgeBaseManagement/KnowledgeBaseQuery/KnowledgeBaseManagementModal）──
  '知识库': 'Knowledge Base',
  '知识库查询': 'Knowledge Base Query',
  '知识库ID': 'Knowledge Base ID',
  '添加下级': 'Add Child',
  '基本信息': 'Basic Information',
  '上级标题': 'Parent Title',
  '标题名称': 'Title Name',
  '知识内容': 'Knowledge Content',
  '知识内容：': 'Knowledge Content:',
  '内容附件': 'Attachment',
  '内容附件：': 'Attachment:',
  '请输入知识库名称': 'Please enter the knowledge base name',
  '请输入知识库ID': 'Please enter the knowledge base ID',
  '请输入标题名称': 'Please enter the title name',
  '请输入标题名称!': 'Please enter the title name!',
  '请输入内容!': 'Please enter the content!',
  '请输入知识内容!': 'Please enter the knowledge content!',
  '请输入创建时间': 'Please enter creation time',
  '请选择上级区域': 'Please select parent area',
  '请先选择一个知识库!': 'Please select a knowledge base first!',
  '请先点击选中上级区域！': 'Please select a parent area first!',
  '请输入备注': 'Please enter remark',

  // ── 通话记录（CallHistory）──
  '来电人员名称': 'Caller Name',
  '来电时间': 'Incoming Call Time',
  '回访': 'Follow-up',
  '回访时间': 'Follow-up Time',
  '是否回访': 'Follow-up Required',
  '咨询类型': 'Inquiry Type',
  '咨询信息': 'Inquiry Information',
  '接线人员名称': 'Answering Staff Name',
  '热线人员名称': 'Hotline Staff Name',
  '热线人员描述': 'Hotline Staff Description',
  '热线人员头像': 'Hotline Staff Avatar',
  '分机号': 'Extension No.',
  '系统登录账号': 'System Login Account',
  '请输入热线人员名称': 'Please enter the hotline staff name',
  '请输入来电人员名称': 'Please enter the caller name',
  '请输入用户水表编号': 'Please enter the customer water meter No.',
  '请输入用户手机号': 'Please enter customer mobile phone',
  '请输入用户编号': 'Please enter customer No.',
  '请输入用户姓名': 'Please enter customer name',
  '请输入表编号': 'Please enter meter No.',
  '请输入咨询信息': 'Please enter the inquiry information',
  '请输入分机号': 'Please enter the extension number',
  '请输入硬件设备名称': 'Please enter the hardware device name',
  '请输入联系电话': 'Please enter contact phone',
  '请选择是否回访': 'Please select whether follow-up is required',
  '请选择咨询类型': 'Please select the inquiry type',
  '请选择接线人员名称': 'Please select the answering staff name',
  '请选择用户满意度': 'Please select customer satisfaction',
  '请选择工单类型': 'Please select work order type',
  '请选择工单紧急程度': 'Please select work order urgency',
  '请选择系统登录账号': 'Please select the system login account',

  // ── 话务员管理（OperatorManagement）──
  '命令服务队列': 'Command Service Queue',
  '命令标识': 'Command ID',
  '命令ID': 'Command ID',
  '通讯状态': 'Communication Status',
  '发送时间': 'Send Time',
  '接收回应时间': 'Response Received At'
}
